<template>
  <v-select
    v-model="item"
    dir="rtl"
    label="Title"
    :reduce="x => x.Id"
    :loading="loading"
    name="test"
    :clearable="clearable"
    :options="stateId ? items.filter(x => x.StateId == stateId) : []"
    @open="onOpen"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'

export default {
  name: 'ZCity',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    stateId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      items: [],
      val: this.value,
      loading: false,
    }
  },
  computed: {
    item: {
      get() {
        if (this.value) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  watch: {
    value(v) {
      this.val = v
    },
    stateId(v, old) {
      if (old) {
        if (v != old) {
          this.item = null
        }
      }
    },
  },
  methods: {
    get() {
      if (this.items.length === 0) {
        this.loading = true
        this.$http.post(
          this.$api.city.getall, {},
        )
          .then(res => {
            this.items = res.data
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
